import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink, Eye, Save, X } from 'lucide-react';

/**
 * MailAttachmentPreviewModal — Fenêtre d'aperçu d'une pièce jointe mail.
 * Composant partagé entre le Hub Com (MailModals) et la fenêtre de rédaction
 * globale (GlobalMailComposeModal) pour éviter toute duplication (DRY).
 *
 * z-[1300] : au-dessus de la fenêtre de rédaction (z-[1200]).
 * Le bouton « Enregistrer dans le CRM » ne s'affiche que si onSaveToCrm est fourni.
 */
const MailAttachmentPreviewModal = ({
  previewModal,
  onClose,
  renderContent,
  onSaveToCrm = null,
  showSuccess = () => {}
}) => {
  const { t } = useTranslation('admin');

  if (!previewModal?.show) return null;

  return (
    <div data-testid="mail-preview-modal" className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[1300] p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl h-[90vh] flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-slate-200">
          <h3 className="text-xl font-bold text-slate-900 flex items-center">
            <Eye size={24} className="mr-3 text-indigo-600" />
            {t('mail.previewOf', { filename: previewModal.filename })}
          </h3>
          <div className="flex items-center space-x-3">
            {onSaveToCrm && (
              <button
                onClick={() => onSaveToCrm(previewModal)}
                className="flex items-center gap-2 px-3 py-1.5 bg-red-50 text-red-600 hover:bg-red-100 rounded-lg transition-colors text-sm font-medium"
                title={t('mail.saveToCrm')}
              >
                <Save size={18} />
                <span className="hidden sm:inline">{t('mail.saveToCrm')}</span>
              </button>
            )}
            <button
              onClick={() => {
                window.open(previewModal.url, '_blank');
                showSuccess(t('mail.fileOpenedNewTab'));
              }}
              className="text-blue-600 hover:text-blue-800 p-2 hover:bg-blue-50 rounded-lg transition-colors"
              title={t('mail.openNewTab')}
            >
              <ExternalLink size={24} />
            </button>
            <button
              data-testid="mail-preview-close"
              onClick={onClose}
              className="text-slate-400 hover:text-slate-600 transition-colors p-2"
              title={t('mail.close')}
            >
              <X size={28} />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-hidden">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default MailAttachmentPreviewModal;
